// extracted by mini-css-extract-plugin
export default {"container":"_0c1534d54e2c983d"};